import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Grid, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { FnDialog, I18n } from 'utilities/utilities';
import { I18NextNs } from 'enum/enum';

const DialogRemark = ({ isOpenRemark, setIsOpenRemark, row, controlledFields, indexClick, setValue, isView }) => {

    const DialogFn = FnDialog();
    const [remark, setRemark] = useState("")

    useEffect(() => {
        if (isOpenRemark && row) {
            setRemark(row.sRemark)
        }
    }, [isOpenRemark, row])


    const handleSubmit = () => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
        DialogFn.CloseSubmit();
            setValue(`lstTicket.${indexClick}.sRemark`, remark);
            controlledFields[indexClick].sRemark = remark;
            setRemark("")
            setIsOpenRemark(false)
        });

    }

    const handleClose = () => {
        setRemark("")
        setIsOpenRemark(false)
    }

    return (
        <DialogPreview
            IsOpen={isOpenRemark}
            Title={"หมายเหตุ"}
            required={true}
            sMaxWidth="sm"
            onClose={handleClose}
            onClick={handleSubmit}
            JsxDialogAction
            CloseSave={!isView}
            Close={!isView}
        >
            <Grid container spacing={1} justifyContent={"center"} alignItems={"start"}>
                <Grid item xs={12}>
                    <TextField
                        id={"sRemark"}
                        name={"sRemark"}
                        value={remark}
                        placeholder={"หมายเหตุ"}
                        variant={"outlined"}
                        type={"text"}
                        size={"small"}
                        fullWidth={true}
                        margin={"normal"}
                        multiline={true}
                        disabled={isView}
                        inputProps={{
                            maxLength: 500
                        }}
                        onChange={(e) => {
                            setRemark(e.target.value)
                        }}
                        minRows={5}
                        maxRows={7}
                        autoComplete={"off"}
                        sx={{
                            "& .MuiOutlinedInput-input": {
                                padding: "9px 10px",
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </DialogPreview>
    )
}

export default DialogRemark
